import { takeEvery, call, put } from 'redux-saga/effects';
import {
    FETCH_CROSS_SELL_AD_IMAGES,
    FETCH_CROSS_SELL_AD_IMAGES_FETCHING,
    FETCH_CROSS_SELL_AD_IMAGES_SUCCESS,
    FETCH_CROSS_SELL_AD_IMAGES_FAIL
} from '../actions/ActionTypes';
import { webApi } from '../config/axios';

// Workers
export function* fetchCrossSellAdImages(action) {
    try {
        yield put({
            type: FETCH_CROSS_SELL_AD_IMAGES_FETCHING
        });

        const response = yield call(webApi.get, `/web-data/image-paths/crossSellAds.json`);

        yield put({
            type: FETCH_CROSS_SELL_AD_IMAGES_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CROSS_SELL_AD_IMAGES_FAIL,
            data: null
        });
    }
}

// Watchers
export const imagePathsSagas = [takeEvery(FETCH_CROSS_SELL_AD_IMAGES, fetchCrossSellAdImages)];
